import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { AssetSubStatus, IconWithTooltip } from "../../../helper/fixcode";
import { Template } from "devextreme-react";
import { assetService } from "../../../apis/apiServices/Asset";
import moment from "moment";
import { askConfirmation, showResponseMessage } from "../../../helper/message";

export default function AssetRequestComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [AddrequestList, setAddrequestList] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Asset Request";
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getAssetRequestLst();
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetRequestLst = async () => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      let body = {
        requestId: 0,
        statusId: AssetSubStatus.AssetRequestPending,
        userId: user?.userId,
      };
      const response = await assetService.addAssetRequestList(body);      
      const data = response?.data.filter(
        (e) =>
          e.statusId !== AssetSubStatus.AssetRequestApprovalCompleted 
          && e.statusId !== AssetSubStatus.AssetRequestApproved
      );
      setAddrequestList(data);
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={AddrequestList}
              ref={refDataGrid}
              keyExpr="requestId"
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              columnAutoWidth={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  {
                    location: "before",
                    template: "toolbarAddTemplate",
                  },
                  {
                    location: "before",
                    template: "toolbarRefreshTemplate",
                  }
                  //   {
                  //     location: "after",
                  //     widget: "dxButton",
                  //     options: {
                  //       icon: "refresh",
                  //       onClick: async () => {
                  //         await getAssetRequestLst();
                  //       },
                  //     },
                  //   }
                );
              }}
            >
              <Column
                dataField="requestId"
                caption=""
                allowExporting={false}
                allowFiltering={false}
                allowSearch={false}
                allowSorting={false}
                width={80}
                cellRender={(cellData) => {
                  const rowData = cellData?.data;
                  const idPrefix = `icon-${rowData?.requestId}`;
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        <span>
                          <IconWithTooltip
                            id={`${idPrefix}-view`}
                            className="iconify-size mr-1"
                            title="View"
                            tooltip="View"
                            icon="solar:document-text-outline"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              navigate("/asset-preview", {
                                state: {
                                  requestId: rowData?.requestId,
                                  sourceUrl: "AssetRequest",
                                  isReport: false,
                                },
                              })
                            }
                          />
                        </span>
                        {
                          rowData.actionAllowed &&
                        // (rowData.statusId ===
                        //   parseInt(AssetSubStatus.AssetRequestPending) ||
                        //   rowData.statusId ===
                        //     parseInt(AssetSubStatus.AssetRequestBackToDraft)) &&
                        //   rowData.fromId === user.userId && 
                          (
                            <>
                              <span>
                                <IconWithTooltip
                                  id={`${idPrefix}-edit`}
                                  className="iconify-size mr-1"
                                  title="Edit"
                                  tooltip="Edit"
                                  icon="solar:pen-line-duotone"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    navigate("/AddAssetRequest", {
                                      state: {
                                        stateData: cellData.data,
                                        requestId: rowData?.requestId,
                                        sourceUrl: "AssetRequest",
                                      },
                                    })
                                  }
                                />
                              </span>
                            </>
                          )}
                        {rowData?.statusId ===
                          AssetSubStatus.AssetRequestPending && (
                          <>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-delete`}
                                className="iconify-size mr-1"
                                title="Delete"
                                tooltip="Delete"
                                icon="fluent:delete-32-regular"
                                style={{ cursor: "pointer" }}
                                onClick={async (e) => {
                                  e.preventDefault();
                                  try {
                                    let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to delete asset request [${rowData?.requestNo}]?</span>`;
                                    let isConfirmed = await askConfirmation(
                                      confirmationQuestion,
                                      "Yes",
                                      "No"
                                    );
                                    if (!isConfirmed) return;
                                    const response =
                                      await assetService.deleteAssetRequest(
                                        rowData?.requestId
                                      );
                                    isConfirmed = await showResponseMessage(
                                      response
                                    );
                                    if (response?.isSuccess) {
                                      await getAssetRequestLst();
                                    }
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                              />
                            </span>
                          </>
                        )}
                      </div>
                    </>
                  );
                }}
              ></Column>
              <Column
                dataField="requestNo"
                caption="Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetStatus"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  let color = "#28A745";
                  if (e.data?.statusId === AssetSubStatus.AssetRequestPending)
                    color = "#494545ff";
                  else if (
                    e.data?.statusId === AssetSubStatus.AssetRequestApproved
                  )
                    color = "#4CAF50";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetRequestSendforApproval
                  )
                    color = "#FF9800";
                  else if (
                    e.data?.statusId === AssetSubStatus.AssetRequestRecall
                  )
                    color = "#ee0a0aff";
                  else if (
                    e.data?.statusId === AssetSubStatus.AssetRequestBackToDraft
                  )
                    color = "#ee0a0aff";

                  return (
                    <div>
                      <span style={{ color }}>{e.data?.assetStatus}</span>
                      {/* <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {e.data?.currentUserId > 0
                          ? e.data?.currentUserName
                          : e.data?.fromName}
                      </div> */}
                    </div>
                  );
                }}
              />
              <Column
                dataField="requestedDate"
                caption="Request Date"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format="dd-MMM-yyyy"
              />
              <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                //alignment={"center"}
                cellRender={(data) => {
                  if (data?.data?.fromName) {
                    return (
                      <>
                        <span>{data?.data?.fromName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.fromDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="toName"
                caption="To"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                //alignment={"center"}
                cellRender={(data) => {
                  if (data?.data?.toName) {
                    return (
                      <>
                        <span>{data?.data?.toName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              {/* <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              <Column
                dataField="projectName"
                caption="Project"
                allowSearch={true}
                allowFiltering={false}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.projectName ?? ""}</span>
                      {data?.data?.locationName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.locationName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="assetDescriptions"
                caption="Asset Name"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              {/* <Column
                dataField="toName"
                caption="To"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              {/* <Column
                dataField="requestSubject"
                caption="Subject"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="requestTypeName"
                caption="Request Type"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              {/* <Column
                dataField="locationName"
                caption="Location"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              {/* <Column
                dataField="requestedCount"
                caption="No Of Assets"
                allowSearch={true}
                allowFiltering={false}
                alignment={"center"}
                allowSorting={true}
              /> */}
              {/* <Column
                dataField="note"
                caption="Note"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              {/* <Column
                dataField="createdByName"
                caption="Created By"
                allowSearch={true}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.createdByName) {
                    return (
                      <>
                        <span>{data?.data?.createdByName ?? ""}</span>
                        <br />
                        <small>
                          {data?.data?.fromDepartment ?? ""}
                        </small>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              /> */}
              {/* <Column
                dataField="createdOn"
                caption="Created On"
                allowSearch={true}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.createdOn) {
                    return (
                      <>
                        <span>{moment(data?.data?.createdOn).format('DD/MM/YYYY') + " " + moment(data?.data?.createdOn).format('LT') ?? ""}</span>
                        <br />
                        <div style={{ color: '#b1b1b1', fontSize: '11px' }}>
                          {data?.data?.createdByName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="updatedByName"
                caption="Last Updated"
                allowSearch={true}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.updatedByName) {
                    return (
                      <>
                        <span>{data?.data?.updatedByName ?? ""}</span>
                        <br />
                        <div style={{ color: '#b1b1b1', fontSize: '11px' }}>
                          {data?.data?.toDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              /> */}
              <Template
                name="toolbarAddTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Add Movement Request"
                        className="btn btn-primary btn-sm mr-1"
                        onClick={(e) => {
                          e.preventDefault();
                          try {
                            navigate("/AddAssetRequest");
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <span title="Add Movement Request">
                          <i className="fas fa-plus"></i>
                          &nbsp;&nbsp;Add
                        </span>
                      </button>
                    </>
                  );
                }}
              />
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            await getAssetRequestLst();
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faRefresh} />
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />
              <Export enabled={true} fileName="Asset Request" />
            </DataGrid>
          </div>
        </div>
      </div>
    </>
  );
}
